import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ActiveFeatureService {
  private featureBaseUrl$ = new BehaviorSubject<string | null>(null);
  private featureTitle$ = new BehaviorSubject<string>("MedicNow");

  readonly baseUrl$ = this.featureBaseUrl$.asObservable();
  readonly title$ = this.featureTitle$.asObservable();

  setFeature(baseUrl: string | null, title?: string) {
    this.featureBaseUrl$.next(baseUrl);
    if (title !== undefined) {
      this.featureTitle$.next(title);
    }
  }

  clearFeature() {
    this.featureBaseUrl$.next(null);
    this.featureTitle$.next("MedicNow");
  }

  getBaseUrl(): string | null {
    return this.featureBaseUrl$.getValue();
  }
}
